import PolicyCard from './policy';
import SecurityPolicy from './information'

const components = {
    PolicyCard,
    SecurityPolicy
}

export default components;